import NotificationRegisterCardComponent from '@components/Notification/notificationRegisterCardComponent';
import { Notification } from '@interfaces/global/notification';
import { NotificationType } from '@interfaces/global/notification-type';
import NotificationService from '@services/global/Notification';
import I18n from '@src/i18n';
import { Button, Col, Menu, Modal, Radio, Row, Tabs } from 'antd';
import React from 'react';

import { locale } from '../../../node_modules/moment';
import styled from './../../styled-components';

const TabPane = Tabs.TabPane;

interface IProp {
  visible: boolean;
  title: string;
  pillar: any;
  client: any;
  type: NotificationType;
  onSaveSelection: Function;
  onCancelSelection: Function;
  notificationId: string;
  notification?: Notification[]
}

interface IState {
  modal2Visible: boolean;
  saving: boolean;
  savingValidationMessage: string;
  showingAdvancedOptions: boolean;
  notificationID: string;
  notificationBlank: string;
  notificationList?: Notification[];
  notificationShowingList?: Notification[];
  isLoadingEmails: boolean;
  senderOptions: any[],
  keyOptions: any[],
  idStart: number;
  checkedSelect?: boolean

  notificationIdSelected: string,
  canSave: boolean
}

/*
    This text is to make sure you understand how to use this component.
    The Notification Register Component is used to allow users to manage all theirs notification.
    And more than that, the page that is calling this component will receive a callback when the user select
    a notification to be used this time.

    "VISIBLE" is a boolean value to show/hide the fullscren modal
    "title" is the title showed at the top of the page
    "PILLAR" this is the current pillar, is necessary to identify exclusive notifications from a determined pillar
    "CLIENT" used to know from what client to get the notifications
    "TYPE" this is the notification type, used to apply some interface changes

    "ON SAVE SELECTION" one of the most important props, this is a Function(e:string)
    this function is called when user select and clicks on save. This will return a parameter of type STRING
*/
class NotificationRegisterComponent extends React.Component<IProp, IState> {
  private _notificationService: NotificationService = new NotificationService(this.props.pillar);

  state: any = {
    modal2Visible: this.props.visible,
    saving: false,
    showingAdvancedOptions: false,
    notificationID: '',
    notificationBlank: '',
    notificationList: [] as Notification[],
    notificationShowingList: [] as Notification[],
    isLoadingEmails: false,
    senderOptions: [],
    keyOptions: [],
    idStart: undefined,
    checkedSelect: false,
    notificationIdSelected: this.props.notificationId || "",
    canSave: false
  }

  componentDidMount() {
    this.getIDEqualsSelected();
    this.getStartNotification();
  }

  getStartNotification = async () => {
    let notificationdata: any = ''
    if (this.props.type === NotificationType.EMAIL){
      notificationdata = await this._notificationService.listAllEmail();
      console.log('Email')
    }
    else {
      notificationdata = await this._notificationService.listAllSMS();
      console.log('SMS')

    }
    // console.log('SMS',this.state.notificationIdSelected )
    if (this.state.idStart !== undefined)
      this.setState({ notificationID: notificationdata[this.state.idStart] })
    console.log('notificationID',this.state.notificationID )


    if (this.state.notificationIdSelected.length > 0) {
      await this.onNotificationListOptionsClicked(this.state.notificationID)
    }

  }

  getIDEqualsSelected = async () => {
    let i: number = 0;
    let notificationid: any = ''
    if (this.props.type === NotificationType.EMAIL){
      notificationid = await this._notificationService.listAllEmail();
    }
    else if (this.props.type === NotificationType.SMS){
      notificationid = await this._notificationService.listAllSMS();
    }
    while (i < notificationid.length) {
      if (notificationid[i].id == this.state.notificationIdSelected)
        this.setState({ idStart: i })
      // console.log('notif map', notificationid.length)
      i++;
    }
  }

  listAllNotifications = async (notificationType: NotificationType) => {
    switch (notificationType) {
      case NotificationType.EMAIL:
        return await this._notificationService.listAllEmail();


      case NotificationType.SMS:
        return await this._notificationService.listAllSMS();

      case NotificationType.PUSH:
        return await this._notificationService.listAllPush();

      default:
        return [];
        break;
    }
  }

  getNotifications = async (notificationType: NotificationType, locale: any) => {
    this.setState({ isLoadingEmails: true });
    try {
      const data = await this.listAllNotifications(notificationType);

      this.setState({
        notificationList: data as Notification[],
        isLoadingEmails: false,
        senderOptions: this.getSenderOptions(this.props.pillar, this.props.client, locale)
      });



    } catch (error) {
      console.warn(error);
      this.setState({
        isLoadingEmails: false,
      });
    }
  }

  setModal2Visible(newValue: boolean) {
    this.setState({ modal2Visible: newValue });
  }

  setAdvanced(newValue: boolean) {
    //console.log("Tooggling showing advanced options!", newValue);
    this.setState({ showingAdvancedOptions: newValue });
  }

  onNotificationSelected = async (e: any, notificationID?: string) => {
    if (notificationID === undefined)
      return;

    this.setState({ checkedSelect: e.target.checked })


    this.setState({ notificationIdSelected: notificationID })
  }

  getIsSelectValue(idToCompare: string | undefined, curIdSelected: string) {
    if (idToCompare === undefined)
      return false;

    const isSelected: boolean = (idToCompare === curIdSelected);
    // console.log("Comparing [" + idToCompare + "] to [" + curIdSelected + "]");
    // console.log("Comparing Result: ", isSelected);

    return isSelected;
  }

  getCanSave(): boolean {
    const selectedId: string = this.state.notificationIdSelected;
    const cantSaveNow: boolean = (selectedId !== undefined) && (selectedId.length > 0);
    //console.log("Can Save Choice: ", cantSaveNow);
    return cantSaveNow;
  }

  onTargetChange(checkedValues: any) {
    console.log('checked = ', checkedValues);
  }

  handleSelectionChange(value: any) {
    console.log(`selected ${value}`);
  }

  onDropDownSelected(selectorClicked: string) {
    console.log(selectorClicked);
  }

  onNotificationListOptionsClicked = async (notification: Notification) => {
    let notificationShowingList: Notification[] = this.state.notificationShowingList;
    notificationShowingList.push(notification);
    this.setState({ notificationShowingList: notificationShowingList });
    console.log('VALOR DA NOt  INICIAL', this.state.notificationShowingList)
  }

  onKeysListOptionsClicked = async (key: string) => {
    console.log(key);
  }

  getSenderOptions(pillar: any, client: any, locale: any) {
    let checkboxOptions = [];

    switch (pillar) {
      case "QAFS":
        checkboxOptions.push({
          label: client.name, value: 1
        }, {
            label: I18n.l('labels.distributor'), value: 2
          }, {
            label: I18n.l('labels.agent'), value: 3
          })
        break;

      case "EHSS":
        checkboxOptions.push({
          label: I18n.l('labels.auditor'), value: 2
        }, {
            label: I18n.l('labels.audited'), value: 1
          })
        break;

      default:
        checkboxOptions.push({
          label: "@Pillar Not Implement", value: 2
        })
        break;
    }
    return (checkboxOptions);
  }


  getSenderOptionsDefautValue(notification: Notification) {
    let defaultValues: number[] = [];
    if (notification.profiles.length > 0) {
      defaultValues = notification.profiles;
    }
    return defaultValues;
  }

  getKeyListOptions(keyList: string[]) {
    return (
      <Menu>
        {
          console.log("Keys to show: ", keyList)
        }
        {
          (keyList.length > 0) && keyList.map((key: string, i: number) => {
            return (
              <Menu.Item key={i} onClick={() => this.onKeysListOptionsClicked(key)}>
                <p>{key}</p>
              </Menu.Item>
            )
          })
        }
      </Menu>
    )
  }

  getNotificationByIDFromList(id: string, notifications: Notification[]): Notification | undefined {
    return notifications.find((not: Notification) => { return not.id === id })
  }

  onDeleteNotification = async (notificationID: string) => {
    // console.log("Notification to delete: ", notificationID);

    const myNotifications = this.removeNotificationFromList(notificationID, this.state.notificationList, false);
    await this.setNewNotificationList(myNotifications);

    const myShowingNotifications = this.removeNotificationFromList(notificationID, this.state.notificationShowingList, false);
    await this.setNewShowingNotificationList(myShowingNotifications);



  }

  removeNotificationFromList(notificationID: string | undefined, notificationList: Notification[], debug: boolean): Notification[] {
    const notificationListToUse: Notification[] = notificationList;

    if (notificationID === undefined || notificationID.length <= 0) {
      if (debug) console.log("Notification is not properly setted: ", notificationID);
      return notificationListToUse;
    } else {
      let indexToRemove: number = -1;
      for (let index = 0; index < notificationListToUse.length; index++) {
        if (notificationListToUse[index].id === notificationID) {
          if (debug) console.log("Found item to delete on index:", index);
          indexToRemove = index;
          break;
        }
      }

      if (indexToRemove === -1)
        notificationListToUse;

      if (indexToRemove !== -1) {
        notificationListToUse.splice(indexToRemove, 1);
        if (debug) console.log("Removing from index: ", indexToRemove);
      }
    }

    return notificationList;
  }

  onCreateNotification = async (notification: Notification) => {
    let notificationList: Notification[] = this.state.notificationList;
    notificationList.push(notification);
    this.setNewNotificationList(notificationList);

    let notificationShowingList: Notification[] = this.state.notificationShowingList;

    if (notificationShowingList)
      notificationShowingList.push(notification);
    this.setNewShowingNotificationList(notificationShowingList);
  }

  addNotificationToList(notification: Notification | undefined, notificationList: Notification[]): Notification[] {
    if (notification === undefined) {
      console.log("Notification Not Found: ", notification);
      return notificationList;

    } else {
      console.log("Mu current notification: ", notificationList);

      let indexToRemove = notificationList.indexOf(notification);
      if (indexToRemove != -1) {
        notificationList.splice(indexToRemove, 1);
        console.log("Removing from index: ", indexToRemove);
      }
    }

    return notificationList;
  }

  onUpdateNotification = async (notification: Notification) => {
    const notificationList: Notification[] = this.updateNotificationOnList(notification, this.state.notificationList);
    this.setNewNotificationList(notificationList);
  }

  updateNotificationOnList(notification: Notification | undefined, notificationList: Notification[]): Notification[] {
    if (notification === undefined) {
      console.log("Notification Not Found: ", notification);
      return notificationList;
    }

    let indexToChange: number = -1;
    for (let index = 0; index < notificationList.length; index++) {
      if (notificationList[index].id === notification.id) {
        indexToChange = index;
      }
    }

    notificationList[indexToChange] = notification;

    return notificationList;
  }

  setNewNotificationList = async (newList: Notification[]) => {
    this.setState({ notificationList: undefined });

    this.setState({ notificationList: newList });
  }

  setNewShowingNotificationList = async (newList: Notification[]) => {
    this.setState({ notificationShowingList: undefined });

    const objectNotification: any = newList.find((object: any) => object.id === "");
    for (let i = 0; i < newList.length; i++) {
      if (newList[i] === objectNotification) {
        await newList.splice(i, 1);
      }
    }
    this.setState({ notificationShowingList: newList });
  }

  createNewPerButton = async () => {
    const listToCreate: Notification[] = this.state.notificationShowingList;
    const newItem: Notification = {
      id: "",
      name: "",
      subject: "",
      content: "",
      profiles: [],
      keys: [],
      type: this.props.type
    }
    listToCreate.push(newItem)
    this.setState({ notificationShowingList: listToCreate })
  }

  getLabelByType(typeWanted: NotificationType): string {
    let typeAsString: string;
    switch (typeWanted) {
      case NotificationType.EMAIL:
        typeAsString = I18n.l("labels.email");
        break;

      case NotificationType.SMS:
        typeAsString = I18n.l("labels.sms");
        break;

      case NotificationType.PUSH:
        typeAsString = I18n.l("labels.push");
        break;

      default:
        console.error("Type wanted is unknown: ", typeWanted);
        return "Type Not Implemented";
    }

    return typeAsString;
  }

  renderNotificationManagement(locale: any) {

    return (
      <TabPane tab={this.getLabelByType(this.props.type)} key="1">
        <Row>
          <Row className="goepik-component-padding">
            <Button type="primary" shape="circle" icon="plus" />
            <Button type="primary" ghost onClick={this.createNewPerButton}>{I18n.l("notificationcard.createnew")}</Button>
          </Row>

          {
            (this.state.notificationShowingList !== undefined) &&
            <Row>
              {

                this.state.notificationShowingList.map((notification: Notification, i: Number) => {
                  return (
                    <div key={i.toString()}>
                    {console.log('asgff', notification)}
                      <Col sm={24} md={11} xl={7}>
                        <NotificationComponent>
                          <div className="goepik-card-space goepik-component-padding">
                            <Radio onChange={(e) => this.onNotificationSelected(e, notification.id || undefined)} checked={this.getIsSelectValue(notification.id, this.state.notificationIdSelected)}>{I18n.l("notificationcard.sendnotification")} </Radio>
                            <NotificationRegisterCardComponent
                              notificationToOpen={notification}
                              pillar={this.props.pillar}
                              senderOptions={this.getSenderOptions(this.props.pillar, this.props.client, locale)}
                              onDelete={this.onDeleteNotification}
                              onCreate={this.onCreateNotification}
                              onUpdate={this.onUpdateNotification}
                              closeModal={this.closeModal}
                            />
                          </div>
                        </NotificationComponent>
                      </Col>
                    </div>
                  )
                })
              }
            </Row>
          }
        </Row>
      </TabPane>
    )
  }

  onCancel() {
    this.setModal2Visible(false);
    this.props.onCancelSelection(this.state.notificationIdSelected);
  }

  onSave() {
    this.setModal2Visible(false);
    this.props.onSaveSelection(this.state.notificationIdSelected);
    console.log('valor após salvar', this.props.onSaveSelection)
  }
  closeModal = async () => {
   await  this.setModal2Visible(false);
    this.props.onSaveSelection(this.state.notificationIdSelected);
  }

  render(): JSX.Element {

    const {
      title,
    } = this.props;

    const {
      modal2Visible,
    } = this.state;

    return (
      <div>
        <FullScreenModalStyle>
          <Modal
            className={"goepik-modal-fullscreen"}
            visible={modal2Visible}
            closable={false}
            maskClosable={false}
            footer={false}
          >
            <Row>
              <Col sm={24} md={24} xl={24}>
                <h1>{I18n.l('titles.notificationTitle')} {title}</h1>
              </Col>
            </Row>
            <Row>
              <Col sm={24} md={24} xl={24}>
                <h4>{I18n.l('titles.notificationTitleSub.first')}</h4>
                <h4>{I18n.l('titles.notificationTitleSub.second')}</h4>
              </Col>
            </Row>
            <Row>
              <Col sm={24} md={24} xl={24}>
                <RegistersButtons>
                  <Button type="primary" ghost size={"large"} className="goepik-margin-btn" onClick={() => this.onCancel()}>{I18n.l('common.cancel').toUpperCase()}</Button>
                </RegistersButtons>
              </Col>
            </Row>

            <Row className="goepik-component-padding">
              <Col sm={24} md={24} xl={24}>
                <Tabs defaultActiveKey="1">
                  {
                    this.renderNotificationManagement(locale)
                  }
                </Tabs>
              </Col>
            </Row>
          </Modal>
        </FullScreenModalStyle>
      </div>
    );
  };
}

const FullScreenModalStyle = styled.div`
    .ant-modal-body {
        height: 100%;
        overflow-y: scroll;
    }
`;

const RegistersButtons = styled.div`
    .ant-btn {
        margin-right: 10px;
    }
`;

const NotificationComponent = styled.div`
    .goepik-card-space{
        margin-right: 4%;
    }
`;


export default NotificationRegisterComponent;
